import { cn } from '@/lib/utils'

/** Figma hero intro copy — 20px Pretendard, centered under page titles. */
export function MarketingHeroLead({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <p className={cn('marketing-hero-lead', className)}>{children}</p>
}
